import { isType } from 'pdf-lib';
import { apiService } from './ApiService'; // Asegúrate de que la ruta sea correcta

class DataHandler {
  constructor(endpointKey, params, accessToken, setData, setLoading, setError) {
    this.endpointKey = endpointKey;
    this.params = params;
    this.accessToken = accessToken;
    this.setData = setData;
    this.setLoading = setLoading;
    this.setError = setError;
  }

  async fetchData() {
    //console.log('this.setLoading en fetchData:', this.setLoading);
    this.setLoading(true);
    this.setError(null);
    try {
      const responseData = await apiService.get(this.endpointKey, this.accessToken, this.params);
      console.dir("Response Data del Fetch (dir):", responseData);
      // console.log("Response Data del Fetch (stringify):", JSON.stringify(responseData, null, 2));
      //console.log("responseData.data antes de setData:", responseData.data); // <-- Agrega este log
        this.setData(responseData.data);
        console.log("setData fue llamada con:", responseData.data); // <-- Agrega este log justo después de llamar a setData
        //console.log("Función de actualización de estado (setData) llamada."); // <-- Nuevo log
        //console.log("Valor de setData (state updater):", this.setData);
         // **Retorna responseData.data para que el await en el componente lo reciba**
        return responseData.data;
    } catch (e) {
      this.setError(e);
      <p>Array Vacío</p>
    } finally {
      this.setLoading(false);
    }
  }

async postData(body) {
  console.warn("Body que entra al postData: " + JSON.stringify(body));
  this.setLoading(true);
  this.setError(null);
  try {
    const responseData = await apiService.post(this.endpointKey, this.accessToken, body, this.params);
    console.warn("el responseData es: " + JSON.stringify(responseData));
    this.setData(responseData); // opcional
    return responseData; // 👈 ESTA línea es fundamental
  } catch (e) {
    this.setError(e);
    throw e;
  } finally {
    this.setLoading(false);
  }
}

//el que siempre funciona sin response data para mostrar la respuesta del servidor
  // async putData(body) {
  //   console.warn("Body que entra al putData" + JSON.stringify(body));
  //   this.setLoading(true);
  //   this.setError(null);
  //   try {
  //     const responseData = await apiService.put(this.endpointKey, this.accessToken, body, this.params);
  //     this.setData(responseData.data); // Puedes manejar la respuesta como necesites
  //   } catch (e) {
  //     this.setError(e);
  //   } finally {
  //     this.setLoading(false);
  //   }
  // }

  async putData(body) {
    console.warn("Body que entra al putData" + JSON.stringify(body));
    this.setLoading(true);
    this.setError(null);
    try {
      const responseData = await apiService.put(this.endpointKey, this.accessToken, body, this.params);
      //this.setData(responseData.data); // Opcional
      return responseData;
      //return responseData.data; // ✅ ESTA línea es fundamental
    } catch (e) {
      this.setError(e);
      throw e; // sigue siendo útil lanzar el error
    } finally {
      this.setLoading(false);
    }
  }
  

  async deleteData() {
    this.setLoading(true);
    this.setError(null);
    try {
      const responseData = await apiService.delete(this.endpointKey, this.accessToken, this.params);
      this.setData(responseData.data); // Puedes manejar la respuesta como necesites
    } catch (e) {
      this.setError(e);
    } finally {
      this.setLoading(false);
    }
  }
}

export default DataHandler;